/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	jQuery('#testimonials_carousel').owlCarousel({
		loop:false,
		margin:45,
		nav:false,
		dots:true,
		autoplay:true,
		autoplayTimeout:15000,
		responsive:{
			0:{
				items:1
			},
			300:{
				items:1
			},
			600:{
				items:1
			},
			900:{
				items:1
			},
			1200:{
				items:2
			},
		}
	});

	new Foundation.Equalizer(jQuery('.row-equalizer'), {'data-equalize-on': 'large'});

	jQuery('a[href="#footer-form"]').on('click', function(event){
		event.preventDefault();
		jQuery('#footer-form').slideDown();
		jQuery('html, body').animate({
			scrollTop: jQuery('#footer-form').offset().top
		}, 500);
	});

	jQuery('.wpcf7 select option').first().attr('disabled', 'disabled');

	// jQuery Magnify
	var $zoom = jQuery('.zoom');
	$zoom.magnify();
	var enabled = true;
	jQuery('#zoom').click(function(){
		if(enabled)
		{
			enabled = false;
			$zoom.destroy();
			jQuery(this).html('<i class="fas fa-search-plus"></i> Enable Zoom');
			jQuery(this).removeClass('secondary');
		}
		else
		{
			enabled = true;
			$zoom.magnify();
			jQuery(this).html('<i class="fas fa-search-minus"></i> Disable Zoom');
			jQuery(this).addClass('secondary');
		}
	});

	// PRINT SUBDIVISION MAP
	jQuery('#print').click(function(){
		var title = document.getElementsByTagName("title")[0].innerHTML;
		var url = jQuery('.zoom').attr('data-magnify-src');

		console.log(title);
		console.log(url);

		printImg(title, url);
	});

	//FINANCING LANDING FORM #1 - Store Values to Cookies
	setTimeout(initializeCountdown, 1000);

	if(jQuery('#wpcf7-f526-p512-o1').length !== 0)
	{
		setFinancialFormCookies('#wpcf7-f526-p512-o1');
	}

	//FINANCING LANDING FORM #2 - Load Values from Cookies
	if(jQuery('#wpcf7-f540-p535-o1').length !== 0)
	{
		if(getCookie('codesm-form-submitted') !== "")
		{
			loadFinancialFormfromCookies();
			jQuery('#hideIfSubmitted').hide();

			var applicant_credit_score = getCookie('codesm-applicant-credit-score');
			var applicant_credit_status, applicant_credit_description;

			switch(applicant_credit_score)
			{
				case "": window.location.href="/60sec/"; break;

				case "450 to 579":	jQuery('#resultGif').attr('src', '/wp-content/themes/pinpoint_construction_v1/assets/images/credit-score/we-can-help.gif');
									applicant_credit_status = 'We Can Help';
									applicant_credit_description = 'Congratulations on taking the first step on your dream home. You\'re credit needs improvement, but we can help!<br />Please contact us right away to take the next step in the process.';
									break;

				case "580 to 619":	jQuery('#resultGif').attr('src', '/wp-content/themes/pinpoint_construction_v1/assets/images/credit-score/fair.gif');
									applicant_credit_status = 'Fair';
									applicant_credit_description = 'Congratulations! You\'re a potential candidate for a home loan.<br />Please contact us right away to take the next step in the process.';
									break;

				case "620 to 679":	jQuery('#resultGif').attr('src', '/wp-content/themes/pinpoint_construction_v1/assets/images/credit-score/good.gif');
									applicant_credit_status = 'Good';
									applicant_credit_description = 'Congratulations! You\'re a very good candidate for a home loan.<br />Please contact us right away to take the next step in the process.';
									break;

				case "680 or above":	jQuery('#resultGif').attr('src', '/wp-content/themes/pinpoint_construction_v1/assets/images/credit-score/excellent.gif');
										applicant_credit_status = 'Excellent';
										applicant_credit_description = 'Congratulations! You\'re an excellent candidate for a home loan.<br />Please contact us right away to take the next step in the process.';
										break;
			}

			setInterval(function(){
				jQuery('#creditStatus').html(applicant_credit_status);
				jQuery('#creditStatusDescription').html(applicant_credit_description);
				jQuery('#creditStatusDescription').slideDown();
			}, 1000);
		}
		else
		{
			window.location.href="/60sec/";
		}
	}

	// PG CALENDAR
	jQuery(function(){
		jQuery('.pg-calendar').pignoseCalendar({
			format: 'MM/DD/YYYY',
			buttons: true,
		});
	});
	
});

function initMap()
{
	var location1 = [`<b class='font-bold'>Pinpoint Construction</b><br />\
						4824 S. Jackson Rd. <br />\
						Edinburg, Texas 78539`, 26.259016, -98.193306]

	var map1 = new google.maps.Map(document.getElementById('location-map'), {
					zoom: 15,
					center: new google.maps.LatLng(26.259016, -98.193306),
					mapTypeId: google.maps.MapTypeId.ROADMAP
				});

	var infowindow1 = new google.maps.InfoWindow({
		content: location1[0],
	});
	var image = "/wp-content/uploads/2018/09/icon-map_marker.png";

	var marker1;
 
	marker1 = new google.maps.Marker({
		position: new google.maps.LatLng(location1[1], location1[2]),
		map: map1,
		icon: image,
	});
	google.maps.event.addListener(marker1, 'click', function() {
		infowindow1.open(map1, marker1);
	});
	infowindow1.open(map1, marker1);
}

function printImg(title, url)
{
	var win = window.open('');
	win.document.write('<h1 style="text-align: center; margin-bottom: 24px;">' + title + '</h1>');
	win.document.write('<img src="/wp-content/uploads/2018/10/subdivision-map-legend.png" style="max-width: 100%; margin: auto; margin-bottom: 16px; display: block; text-align: center;" />');
	win.document.write('<img src="' + url + '" style="max-width: 100%; margin: auto; display: block; text-align: center;" onload="window.print();window.close()" />');
	win.focus();
}

function setCookie(cname, cvalue, exdays)
{
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function deleteCookie(cname)
{
	document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
}

/*function getCookie(cname)
{
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}*/

function getCookie(cname)
{
	var b = document.cookie.match('(^|;)\\s*' + cname + '\\s*=\\s*([^;]+)');
	return b ? b.pop() : '';
}

function setFinancialFormCookies(form)
{
	var full_name = jQuery(form).find('input[name="full-name"]');
	full_name.on('change paste keyup', function(){
		if(getCookie('codesm-full-name') !== "")
		{
			deleteCookie('codesm-full-name');
		}
		setCookie('codesm-full-name', full_name.val(), 1);
	});

	var applicant_address = jQuery(form).find('input[name="applicant-address"]');
	applicant_address.on('change paste keyup', function(){
		if(getCookie('codesm-applicant-address') !== "")
		{
			deleteCookie('codesm-applicant-address');
		}
		setCookie('codesm-applicant-address', applicant_address.val(), 1);
	});

	var mobile_phone = jQuery(form).find('input[name="mobile-phone"]');
	mobile_phone.on('change paste keyup', function(){
		if(getCookie('codesm-mobile-phone') !== "")
		{
			deleteCookie('codesm-mobile-phone');
		}
		setCookie('codesm-mobile-phone', mobile_phone.val(), 1);
	});

	var email = jQuery(form).find('input[name="email"]');
	email.on('change paste keyup', function(){
		if(getCookie('codesm-email') !== "")
		{
			deleteCookie('codesm-email');
		}
		setCookie('codesm-email', email.val(), 1);
	});

	/*var applicant_ssn = jQuery(form).find('input[name="applicant-ssn"]');
	applicant_ssn.on('change paste keyup', function(){
		if(getCookie('codesm-applicant-ssn') !== "")
		{
			deleteCookie('codesm-applicant-ssn');
		}
		setCookie('codesm-applicant-ssn', applicant_ssn.val(), 1);
	});*/

	var applicant_dob = jQuery(form).find('input[name="applicant-dob"]');
	applicant_dob.on('change paste keyup', function(){
		if(getCookie('codesm-applicant-dob') !== "")
		{
			deleteCookie('codesm-applicant-dob');
		}
		setCookie('codesm-applicant-dob', applicant_dob.val(), 1);
	});

	var applicant_gross_monthly_salary = jQuery(form).find('input[name="applicant-gross-monthly-salary"]');
	applicant_gross_monthly_salary.on('change paste keyup', function(){
		if(getCookie('codesm-applicant-gross-monthly-salary') !== "")
		{
			deleteCookie('codesm-applicant-gross-monthly-salary');
		}
		setCookie('codesm-applicant-gross-monthly-salary', applicant_gross_monthly_salary.val(), 1);
	});
	
	var applicant_number_of_years = jQuery(form).find('input[name="applicant-number-of-years"]');
	applicant_number_of_years.on('change paste keyup', function(){
		if(getCookie('codesm-applicant-number-of-years') !== "")
		{
			deleteCookie('codesm-applicant-number-of-years');
		}
		setCookie('codesm-applicant-number-of-years', applicant_number_of_years.val(), 1);
	});

	var applicant_monthly_payment_desired = jQuery(form).find('input[name="applicant-monthly-payment-desired"]');
	applicant_monthly_payment_desired.on('change paste keyup', function(){
		if(getCookie('codesm-applicant-monthly-payment-desired') !== "")
		{
			deleteCookie('codesm-applicant-monthly-payment-desired');
		}
		setCookie('codesm-applicant-monthly-payment-desired', applicant_monthly_payment_desired.val(), 1);
	});

	var applicant_credit_score = jQuery(form).find('select[name="applicant-credit-score"]');
	applicant_credit_score.on('change paste keyup', function(){
		if(getCookie('codesm-applicant-credit-score') !== "")
		{
			deleteCookie('codesm-applicant-credit-score');
		}
		setCookie('codesm-applicant-credit-score', applicant_credit_score.find('option:selected').val(), 1);
	});
}

function loadFinancialFormfromCookies()
{
	jQuery('input[name="full-name"]').val(getCookie('codesm-full-name'));
	jQuery('input[name="applicant-address"]').val(getCookie('codesm-applicant-address'));
	jQuery('input[name="mobile-phone"]').val(getCookie('codesm-mobile-phone'));
	jQuery('input[name="email"]').val(getCookie('codesm-email'));
	/*jQuery('input[name="applicant-ssn"]').val(getCookie('codesm-applicant-ssn'));*/
	jQuery('input[name="applicant-dob"]').val(getCookie('codesm-applicant-dob'));
	jQuery('input[name="applicant-gross-monthly-salary"]').val(getCookie('codesm-applicant-gross-monthly-salary'));
	jQuery('input[name="applicant-number-of-years"]').val(getCookie('codesm-applicant-number-of-years'));
	jQuery('input[name="applicant-monthly-payment-desired"]').val(getCookie('codesm-applicant-monthly-payment-desired'));
	jQuery('select[name="applicant-credit-score"]').val(getCookie('codesm-applicant-credit-score'));
}

function deleteFinancialFormCookies()
{
	deleteCookie('codesm-form-submitted');
	deleteCookie('codesm-full-name');
	deleteCookie('codesm-applicant-address');
	deleteCookie('codesm-mobile-phone');
	deleteCookie('codesm-email');
	/*deleteCookie('codesm-applicant-ssn');*/
	deleteCookie('codesm-applicant-dob');
	deleteCookie('codesm-applicant-gross-monthly-salary');
	deleteCookie('codesm-applicant-number-of-years');
	deleteCookie('codesm-applicant-monthly-payment-desired');
	deleteCookie('codesm-applicant-credit-score');
}

function initializeCountdown()
{
	var initialTime = parseInt(jQuery("#seconds").html(), 10);
	var countdown = setInterval(function(){
		jQuery("#seconds").html(--initialTime);
		if(initialTime <= 0)
			clearInterval(countdown);
	},1000);
}